import { render, staticRenderFns } from "./Screenshots.vue?vue&type=template&id=efd4e472&"
import script from "./Screenshots.vue?vue&type=script&lang=js&"
export * from "./Screenshots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports